<div class="withdraw-container">
  <div class="title">Withdraw</div>
  <mat-dialog-content>
    <span class="body">For withdraw request, Please contact with Support team.</span>
    <button mat-flat-button class="tonal-btn" (click)="closeDialog()">OK</button>
  </mat-dialog-content>
</div>
